<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/sabg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">销售业务</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            统一管理销售各个环节，紧密跟踪客户的每一步；建立销售漏斗的全程跟踪管理，<br> 线索、
            客户、商机各个击破；分析销售行为，关联客户事项的拜访联系记录；<br>自定义客户标签，
            跟踪、记录客户行为，识别高价值线索；优化销售过程，<br>加强销售管理，提高销售业绩！
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/sa1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon1.png" alt="">
            </div>
            <div class="tip">
              销售项目
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立每个销售自己的项目库，所有销售项目
                      有序分段管理；销售项目在线化更方便销售人员随时查看了
                      解状况；销售项目关联商机，精准分析项目的关注度
                      情况；统一管理销售项目信息，实现销售项目全流
                      程化、精细化管理
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/sa2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon2.png" alt="">
            </div>
            <div class="tip">
              拜访客户
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      记录销售对客户的每次拜访、沟通等交流
                      信息，跟进过程有形化；关联汇总客户相关的
                      审批、方案、合同等所有信息，记录完整业务过程；
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/sa3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon3.png" alt="">
            </div>
            <div class="tip">
              我的报价
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      规范标准化报价体系，建立报价审批流程，
                      避免随意报价造成的损失，减少报价不合规
                      的风险
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/sa4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon4.png" alt="">
            </div>
            <div class="tip">
              报价参考
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      一键添加产品，并直接调取产品价格，根据
                      实际需求提交价格折扣；订单提交直接调用
                      维护好的价格目录，快速便捷；同类客户
                      报价，一键“价格共享”，无需重复新建；
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/sa5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon5.png" alt="">
            </div>
            <div class="tip">
              我的合同
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      无纸化办公，改善以往纸质合同管理困难，
                      不易查找调用的情况；
                      客户、供应商、合作伙伴等所有签订合同统
                      一管理；
                      自动统计回款总金额、未回款等数据，实时
                      掌握团队业绩动态
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/sa6.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/saicon6.png" alt="">
            </div>
            <div class="tip">
              我的客户
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      帮助销售管理好手上的客户资源，通过客户
                      信息、联系过程、关联事项等的管理，与客
                      户建立紧密的联系，有助于更好的客户维护；
                      帮助销售灵活、科学规划销售组织与资源；
                      分析好客户的跟进过程、帮助销售管理售后
                      服务全流程
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'SalesBusiness',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
